const PURCHASE_LIST = "admin/purchases/list?";
const PURCHASE_DETAILS = "/admin/purchases";

const apiUrl = {
  PURCHASE_LIST,
  PURCHASE_DETAILS,
};

export default apiUrl;
